<template>
  <el-row style="padding: 5px 15px;" type="flex" justify="space-between">
    <span>
      <el-tooltip v-show="showPingButton" content="Ping" placement="top">
        <el-button class="tool-button ping" type="content" size="medium" @click="excuteLauncher('PING')"/>
      </el-tooltip>
      <el-tooltip v-show="showTerminalButton" content="터미널" placement="top">
        <el-button class="tool-button terminal" type="content" size="medium" @click="excuteLauncher('TERMINAL')"/>
        <!-- <el-button icon="far fa-terminal" size="medium"></el-button> -->
      </el-tooltip>
      <el-tooltip v-show="showTraceRouteButton" content="IP Scan" placement="top" v-if="isObj">
        <el-button class="tool-button trace-route" type="content" size="medium" @click="onIpScanButtonClick"/>
        <!-- <el-button v-else class="tool-button" icon="fas fa-route" size="medium" @click="excuteLauncher('TERMINAL')"></el-button> -->
      </el-tooltip>
      <el-tooltip v-show="showTraceRouteButton" content="Trace Route" placement="top" v-if="!isObj">
        <el-button class="tool-button trace-route2" type="content" size="medium"  @click="excuteLauncher('TRACE_ROUTE')"/>
      </el-tooltip>
      <el-tooltip v-show="showWebLinkButton" content="MIB Browser" placement="top" v-if="isObj">
        <el-button class="tool-button web-link" type="content" size="medium" @click="onMibBrowserButtonClick"/>
      </el-tooltip>
      <el-tooltip v-show="showWebLinkButton" content="Web Link" placement="top" v-if="!isObj">
        <el-button class="tool-button web-link2" type="content" size="medium" @click="excuteLauncher('LINK_WWW')"/>
      </el-tooltip>
      <!-- <el-tooltip v-show="showWebLinkButton" content="Web Link" placement="top">
        <el-button class="tool-button web-link" type="content" size="medium" @click="excuteLauncher('LINK_WWW')"/>
      </el-tooltip> -->
    </span>
    <span v-if="showHambugerButton">
      <el-button icon="edit" size="drawer" @click="openPopup" class="mr-t8"><i class="fas fa-bars"></i></el-button>
      <w-sliding-popup ref="slidingPopup" title="설정" width="350px">
        <div slot="content">
          <component :is="currentView" :obj-info="objInfo" @change-page="closePopup"></component>
        </div>
      </w-sliding-popup>
    </span>
  </el-row>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import { applicationLauncher } from '@/utils/applauncher';
import appApi from '@/api/common/app';
import WServerSlidingButtonGroup from '@/views/performance/node/popup/components/ServerSlidingButtonGroup';
import WNetdeviceSlidingButtonGroup from '@/views/performance/node/popup/components/NetdeviceSlidingButtonGroup';
import WNetinterfaceSlidingButtonGroup from '@/views/performance/node/popup/components/NetinterfaceSlidingButtonGroup';
import WDatabaseSlidingButtonGroup from '@/views/performance/node/popup/components/DatabaseSlidingButtonGroup';
import WEtcSlidingButtonGroup from '@/views/performance/node/popup/components/EtcSlidingButtonGroup';
import WServiceSlidingButtonGroup from '@/views/performance/node/popup/components/ServiceSlidingButtonGroup';
import WVirtualSlidingButtonGroup from '@/views/performance/node/popup/components/VirtualSlidingButtonGroup';
import WApSlidingButtonGroup from '@/views/performance/node/popup/components/ApSlidingButtonGroup';

export default {
  name: 'WManageToolShortenSet',
  components: {
    WServerSlidingButtonGroup,
    WNetdeviceSlidingButtonGroup,
    WNetinterfaceSlidingButtonGroup,
    WDatabaseSlidingButtonGroup,
    WEtcSlidingButtonGroup,
    WServiceSlidingButtonGroup,
    WVirtualSlidingButtonGroup,
    WApSlidingButtonGroup,
  },
  props: {
    /* eslint-disable arrow-body-style */
    obj: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isObj: {
      type: Boolean,
      default: false,
    },
    /* eslint-enable arrow-body-style */
  },
  data() {
    return {
      currentView: null,
    };
  },
  computed: {
    showPingButton() {
      const obj = this.obj;
      return (obj.objManagetypeId === 'VMS' ? obj.objtypeId === 'VHO' || obj.objtypeId === 'VVM' : obj.objManagetypeId !== 'SVC') && this.obj.isStandalone;
    },
    showTraceRouteButton() {
      const obj = this.obj;
      return (obj.objManagetypeId === 'VMS' ? obj.objtypeId === 'VHO' || obj.objtypeId === 'VVM' : obj.objManagetypeId !== 'SVC') && this.obj.isStandalone;
    },
    showWebLinkButton() {
      return this.obj.objManagetypeId !== 'SVC' && this.obj.isStandalone;
    },
    showTerminalButton() {
      return (this.obj.objManagetypeId === 'VMS' ? this.obj.objtypeId === 'VHO' : this.obj.objManagetypeId !== 'SVC') && this.obj.isStandalone;
    },
    showHambugerButton() {
      return this.isObj;
    },
    objInfo() {
      return {
        label: this.obj.objName,
        obj: this.obj,
        subType: (this.obj.objtypeId === 'AP_CONTROLLER') ? 'ap_controller' : 'wireless_ap',
      };
    },
  },
  watch: {
    obj: {
      handler(value) {
        if (value) {
          this.loadComponent();
        }
      },
      immediate: true,
    },
  },
  methods: {
    initData() {
      // #53500 일감과 관련된 코드
      // CommonSettingChartTypePopupButton.vue에 hypervisorType 값을 전달하기 위해
      // ObjectMajorInfoPopup.vue에서 현재 컴포넌트의 ref를 등록 후 현재 컴포넌트의 setData를 호출하도록 했다.
      // 하지만 ref를 등록하게 되면 ObjectMajorInfoPopup.vue에서 initData()를 모든 refs에 대해서 수행하기 때문에
      // 이 함수가 없을 경우 에러가 발생한다.
    },
    setData(majorData) {
      this.objInfo.hypervisorType = majorData.basicinfoSubid;
    },
    loadComponent() {
      const subType = this.obj.objDefineId;
      if (subType === 'SERVER') {
        this.currentView = WServerSlidingButtonGroup.name;
      } else if (subType === 'NETDEVICE') {
        this.currentView = WNetdeviceSlidingButtonGroup.name;
      } else if (subType === 'NETINTERFACE') {
        this.currentView = WNetinterfaceSlidingButtonGroup.name;
      } else if (subType === 'DBMS') {
        this.currentView = WDatabaseSlidingButtonGroup.name;
      } else if (subType === 'SERVICE') {
        this.currentView = WServiceSlidingButtonGroup.name;
      } else if (subType === 'VIRTUAL') {
        this.currentView = WVirtualSlidingButtonGroup.name;
      } else if (subType === 'WIRELESS_DEVICE') {
        this.currentView = (this.obj.objtypeId === 'AP_CONTROLLER') ? WNetdeviceSlidingButtonGroup.name : WApSlidingButtonGroup.name;
      } else {
        this.currentView = WEtcSlidingButtonGroup.name;
      }
    },
    onIpScanButtonClick() {
      applicationLauncher().openIpScanPopup(this.obj.objId);
    },
    onMibBrowserButtonClick() {
      applicationLauncher().openMibBrowserPopup(this.obj.objId);
    },
    excuteLauncher(exectype) {
      let executeType = exectype;
      if (this.obj.objId) {
        appApi.getAppExecuteInfo(this.obj.objId).then((response) => {
          if (response.data.success && !isEmpty(response.data.data)) {
            const obj = response.data.data;
            if (executeType === 'TERMINAL') {
              executeType = obj.useSSH ? 'SSH' : 'TELNET';
            }
            applicationLauncher().directExecute(executeType, obj, this);
          }
        });
      } else if (!this.isObj) { // 연결장비 일 경우
        if (executeType === 'TERMINAL') {
          executeType = 'TELNET';
        }
        const object = {
          ipaddressApplytype: 'IPv4',
          ipaddressIpv4: this.obj.ipaddress,
          objtypeId: this.obj.objtypeId,
        };
        applicationLauncher().directExecute(executeType, object, this);
      }
    },
    openPopup() {
      const { obj } = this.objInfo;
      if (obj.objDefineId === 'E2E_SERVICE') {
        this.objInfo.rscKey = `${obj.transactionId}.${obj.serviceId}`;
        obj.objId = obj.serviceId;
      }
      this.$refs.slidingPopup.open();
    },
    closePopup() {
      this.$refs.slidingPopup.close();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/major-info/components/ManageToolShortenSet.vue